import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import Loading from '@/components/shared/Loading'
import { ErrorBoundary } from '@/components/shared'

const Home = lazy(() => import('@/pages/home'))
const Vehicles = lazy(() => import('@/pages/vehicles'))
const VehicleDetail = lazy(() => import('@/pages/VehicleDetail'))
const Inquiry = lazy(() => import('@/pages/inquiry'))
const Track = lazy(() => import('@/pages/track'))
const TrackSearch = lazy(() => import('@/pages/TrackSearch'))
const About = lazy(() => import('@/pages/about'))
const NotFound = lazy(() => import('@/pages/NotFound'))

function PageLoading() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Loading />
    </div>
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Layout>
          <Suspense fallback={<PageLoading />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vehicles" element={<Vehicles />} />
              <Route path="/vehicles/:id" element={<VehicleDetail />} />
              <Route path="/inquiry" element={<Inquiry />} />
              <Route path="/track" element={<Track />} />
              <Route path="/track-search" element={<TrackSearch />} />
              <Route path="/about" element={<About />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
